// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3XkKX","footer":"ModalCreateQualiphyProcedure_footer__26H9i","additionData":"ModalCreateQualiphyProcedure_additionData__VFLWI"};